import PracticeAreaTemplate from '../../components/PracticeAreaTemplate';
import { usePracticeArea } from '../../hooks/usePracticeArea';

export default function LabourPage() {
  const pa = usePracticeArea('labour');
  return <PracticeAreaTemplate pa={pa} />;
}
